import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 28H7v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .53.21 1.04.59 1.41S6.47 30 7 30h2c.55 0 1-.45 1-1s-.45-1-1-1M26.92 11.62a.9.9 0 0 0-.22-.32l-7-7c-.09-.09-.2-.17-.32-.22S19.13 4 18.99 4h-4c-.55 0-1 .45-1 1s.45 1 1 1h3v6c0 .55.45 1 1 1h6v5c0 .55.45 1 1 1s1-.45 1-1v-6c0-.13-.03-.26-.08-.38zM20 7.42l3.59 3.59H20zM10 4H7c-.53 0-1.04.21-1.41.59S5 5.47 5 6v3c0 .55.45 1 1 1s1-.45 1-1V6h3c.55 0 1-.45 1-1s-.45-1-1-1M26 22c-.55 0-1 .45-1 1v5h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.53 0 1.04-.21 1.41-.59S27 28.53 27 28v-5c0-.55-.45-1-1-1M6 20c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1M19 28h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
const SvgIconFileDotted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileDotted);
export default Memo;
